import React, { useEffect, useState } from 'react';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Slider,
  Box,
  Divider,
  Hidden,
  Card,
  CardContent,
  CardActions,
  Chip,
  Tooltip,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import useApi from '../../../utils/useApi';
import UIContainer from '../../../components/UI/Container/UIContainer';
import UIFormTitle from '../../../components/UI/Form/Title/UIFormTitle';
import PageContent from '../../../components/Main/Content/mainContent';
import { useTutorial } from '../../../components/UI/Tutorial/TutorialProvider';

const GENDER_OPTIONS = [
  { id: 1, label: 'Masculino' },
  { id: 2, label: 'Feminino' },
  { id: 3, label: 'Indefinido' },
];

const MARIAL_STATUS_OPTIONS = [
  { id: 1, label: 'Solteiro' },
  { id: 2, label: 'Casado' },
  { id: 3, label: 'Divorciado' },
];

function parseRange(strValue, defaultMin, defaultMax) {
  if (!strValue || strValue === "NULL" || strValue === "") return [defaultMin, defaultMax];
  const delimiter = String(strValue).includes('~') ? '~' : (String(strValue).includes(',') ? ',' : null);
  if (delimiter) {
    const parts = String(strValue).split(delimiter);
    if (parts.length === 2) {
      return [parseInt(parts[0]) || defaultMin, parseInt(parts[1]) || defaultMax];
    }
  }
  return [defaultMin, defaultMax];
}

const FilterRow = ({ title, emptyText, hasValue, onClear, children }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const showContent = isHovered || isOpen || hasValue;

  return (
    <Box 
      onMouseEnter={() => setIsHovered(true)} 
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => { if (!showContent) setIsOpen(true); }}
      style={{ 
        padding: '12px 16px', 
        borderRadius: '8px', 
        transition: 'background 0.2s', 
        background: isHovered || isOpen ? (document.body?.className?.includes('dark') ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)') : 'transparent', 
        marginBottom: '16px',
        border: hasValue ? '1px solid rgba(0,0,0,0.1)' : '1px solid transparent',
        cursor: !showContent ? 'pointer' : 'default',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" color={hasValue ? "primary" : "textSecondary"}>{title}</Typography>
        {hasValue && (
           <IconButton size="small" onClick={(e) => { e.stopPropagation(); setIsOpen(false); onClear(); }} style={{ padding: 2 }}>
             <DeleteIcon fontSize="small" />
           </IconButton>
        )}
      </Box>
      <Box position="relative">
        <Box style={{ opacity: showContent ? 1 : 0, transition: 'opacity 0.2s', pointerEvents: showContent ? 'auto' : 'none' }}>
          {children}
        </Box>
        <Box position="absolute" top={0} left={0} style={{ opacity: showContent ? 0 : 1, transition: 'opacity 0.2s', pointerEvents: 'none' }}>
          <Typography variant="body2" color="textSecondary">{emptyText}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

const PerfisCliente = () => {
  const { startTour } = useTutorial();
  const [profiles, setProfiles] = useState([]);
  const [customersCities, setCustomersCities] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  // Estados locais para os UI components
  const [ageRangeArr, setAgeRangeArr] = useState([18, 65]);
  const [childrenArr, setChildrenArr] = useState([0, 5]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedMarial, setSelectedMarial] = useState([]);
  const [enableAge, setEnableAge] = useState(false);
  const [enableChildren, setEnableChildren] = useState(false);

  const [ticketAvgRangeArr, setTicketAvgRangeArr] = useState([0, 1000]);
  const [ticketAvgMin, setTicketAvgMin] = useState(0);
  const [enableTicketAvg, setEnableTicketAvg] = useState(false);

  const [totalSalesValueRangeArr, settotalSalesValueRangeArr] = useState([0, 5000]);
  const [totalSalesValueMin, settotalSalesValueMin] = useState(0);
  const [enableTotalSales, setEnableTotalSales] = useState(false);

  const [pendingSalesCountRangeArr, setpendingSalesCountRangeArr] = useState([0, 10]);
  const [pendingSalesCountMin, setpendingSalesCountMin] = useState(0);
  const [enablePendingSales, setEnablePendingSales] = useState(false);

  const [unpaidValueRangeArr, setUnpaidValueRangeArr] = useState([0, 2000]);
  const [unpaidValueMin, setUnpaidValueMin] = useState(0);
  const [enableUnpaidValue, setEnableUnpaidValue] = useState(false);

  const [totalDiscountsRangeArr, setTotalDiscountsRangeArr] = useState([0, 500]);
  const [totalDiscountsMin, setTotalDiscountsMin] = useState(0);
  const [enableTotalDiscounts, setEnableTotalDiscounts] = useState(false);

  const [recencyRangeArr, setRecencyRangeArr] = useState([0, 90]);
  const [recencyMin, setRecencyMin] = useState(0);
  const [enableRecency, setEnableRecency] = useState(false);

  const [tenureRangeArr, setTenureRangeArr] = useState([0, 365]);
  const [tenureMin, setTenureMin] = useState(0);
  const [enableTenure, setEnableTenure] = useState(false);

  const [payIntervalRangeArr, setPayIntervalRangeArr] = useState([0, 30]);
  const [payIntervalMin, setPayIntervalMin] = useState(0);
  const [enablePayInterval, setEnablePayInterval] = useState(false);

  const [profileType, setProfileType] = useState(1);

  const [loadInfo, info] = useApi({
    method: 'get',
    url: '/customers/profiles',
    onCompleted: (res) => {
      if (res && res.data) {
        setProfiles(res.data);
      }
    },
  });

  const [loadCustomers, customersInfo] = useApi({
    method: 'get',
    url: '/customers',
    onCompleted: (res) => {
      if (res && res.data) {
        const uniqueCities = [...new Set(res.data.map(c => c.city).filter(Boolean))];
        setCustomersCities(uniqueCities);
      }
    }
  });

  const [saveLoad, saveInfo] = useApi({
    method: 'post',
    url: '/customers/profiles',
    onCompleted: () => {
      setOpenModal(false);
      loadInfo();
    }
  });

  const [updateLoad, updateInfo] = useApi({
    method: 'put',
    url: '/customers/profiles',
    onCompleted: () => {
      setOpenModal(false);
      loadInfo();
    }
  });

  const [deleteLoad] = useApi({
    method: 'delete',
    url: '/customers/profiles',
    onCompleted: () => {
      loadInfo();
    }
  });

  useEffect(() => {
    loadInfo();
    loadCustomers();
  }, []);

  const handleOpenModal = (profile = null) => {
    const isNew = !profile;
    setSelectedProfile(profile || {
      name: '',
      description: '',
      ageRange: '',
      genders: '',
      marialStatus: '',
      childrenRange: '',
      cities: '',
      neighborhoods: '',
      streets: '',
    });

    // Hidratar os componentes React e os Switches
    setAgeRangeArr(parseRange(profile?.ageRange, 18, 65));
    setChildrenArr(parseRange(profile?.childrenRange, 0, 5));
    setEnableAge(!!profile?.ageRange && profile?.ageRange !== "NULL" && profile?.ageRange !== "");
    setEnableChildren(!!profile?.childrenRange && profile?.childrenRange !== "NULL" && profile?.childrenRange !== "");

    setTicketAvgRangeArr(parseRange(profile?.ticketAvgRange, 0, 1000));
    setTicketAvgMin(profile?.ticketAvgMin || 0);
    setEnableTicketAvg(!!profile?.ticketAvgRange && profile?.ticketAvgRange !== "NULL" && profile?.ticketAvgRange !== "" && !(Number(profile?.ticketAvgMin) > 0));

    settotalSalesValueRangeArr(parseRange(profile?.totalSalesValueRange, 0, 5000));
    settotalSalesValueMin(profile?.totalSalesValueMin || 0);
    setEnableTotalSales(!!profile?.totalSalesValueRange && profile?.totalSalesValueRange !== "NULL" && profile?.totalSalesValueRange !== "" && !(Number(profile?.totalSalesValueMin) > 0));

    setpendingSalesCountRangeArr(parseRange(profile?.pendingSalesCountRange, 0, 10));
    setpendingSalesCountMin(profile?.pendingSalesCountMin || 0);
    setEnablePendingSales(!!profile?.pendingSalesCountRange && profile?.pendingSalesCountRange !== "NULL" && profile?.pendingSalesCountRange !== "" && !(Number(profile?.pendingSalesCountMin) > 0));

    setUnpaidValueRangeArr(parseRange(profile?.unpaidValueRange, 0, 2000));
    setUnpaidValueMin(profile?.unpaidValueMin || 0);
    setEnableUnpaidValue(!!profile?.unpaidValueRange && profile?.unpaidValueRange !== "NULL" && profile?.unpaidValueRange !== "" && !(Number(profile?.unpaidValueMin) > 0));

    setTotalDiscountsRangeArr(parseRange(profile?.totalDiscountsRange, 0, 500));
    setTotalDiscountsMin(profile?.totalDiscountsMin || 0);
    setEnableTotalDiscounts(!!profile?.totalDiscountsRange && profile?.totalDiscountsRange !== "NULL" && profile?.totalDiscountsRange !== "" && !(Number(profile?.totalDiscountsMin) > 0));

    setRecencyRangeArr(parseRange(profile?.recencyRange, 0, 90));
    setRecencyMin(profile?.recencyMin || 0);
    setEnableRecency(!!profile?.recencyRange && profile?.recencyRange !== "NULL" && profile?.recencyRange !== "" && !(Number(profile?.recencyMin) > 0));

    setTenureRangeArr(parseRange(profile?.tenureRange, 0, 365));
    setTenureMin(profile?.tenureMin || 0);
    setEnableTenure(!!profile?.tenureRange && profile?.tenureRange !== "NULL" && profile?.tenureRange !== "" && !(Number(profile?.tenureMin) > 0));

    setPayIntervalRangeArr(parseRange(profile?.payIntervalRange, 0, 30));
    setPayIntervalMin(profile?.payIntervalMin || 0);
    setEnablePayInterval(!!profile?.payIntervalRange && profile?.payIntervalRange !== "NULL" && profile?.payIntervalRange !== "" && !(Number(profile?.payIntervalMin) > 0));

    setProfileType(profile?.profileType || 1);
    
    // Cidades
    if (!isNew && profile.cities && profile.cities !== "NULL") {
      try {
        // Verifica se é o antigo formato (objeto JSON) ou string com vírgula
        if (profile.cities.startsWith('{') || profile.cities.startsWith('[')) {
          const parsed = JSON.parse(profile.cities);
          if (Array.isArray(parsed)) setSelectedCities(parsed);
          else setSelectedCities(Object.values(parsed));
        } else {
          setSelectedCities(profile.cities.split(',').map(s => s.trim()));
        }
      } catch {
        setSelectedCities(profile.cities.split(',').map(s => s.trim()));
      }
    } else {
      setSelectedCities([]);
    }

    // Gêneros
    if (!isNew && profile.genders && profile.genders !== "NULL") {
      try {
        let parsed = profile.genders;
        if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        const mapped = Array.isArray(parsed) ? parsed.map(id => GENDER_OPTIONS.find(o => o.id == id)).filter(Boolean) : [];
        setSelectedGenders(mapped);
      } catch { setSelectedGenders([]); }
    } else {
       setSelectedGenders([]);
    }
    
    // Estado Civil
    if (!isNew && profile.marialStatus && profile.marialStatus !== "NULL") {
      try {
        let parsed = profile.marialStatus;
        if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        const mapped = Array.isArray(parsed) ? parsed.map(id => MARIAL_STATUS_OPTIONS.find(o => o.id == id)).filter(Boolean) : [];
        setSelectedMarial(mapped);
      } catch { setSelectedMarial([]); }
    } else {
       setSelectedMarial([]);
    }

    setOpenModal(true);
  };

  const handleChange = (e) => {
    setSelectedProfile({
      ...selectedProfile,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = () => {
    // Monta o payload processando o JSON a partir dos React States UI
    const payload = { ...selectedProfile };

    // Range Sliders (apenas se a chave-switch estiver ligada)
    payload.ageRange = enableAge ? `${ageRangeArr[0]}~${ageRangeArr[1]}` : "";
    payload.childrenRange = enableChildren ? `${childrenArr[0]}~${childrenArr[1]}` : "";
    
    // Cities to String
    payload.cities = selectedCities.join(', ');

    // Financial Rules
    payload.ticketAvgRange = enableTicketAvg ? `${ticketAvgRangeArr[0]}~${ticketAvgRangeArr[1]}` : "";
    payload.ticketAvgMin = ticketAvgMin > 0 ? ticketAvgMin : null;
    payload.totalSalesValueRange = enableTotalSales ? `${totalSalesValueRangeArr[0]}~${totalSalesValueRangeArr[1]}` : "";
    payload.totalSalesValueMin = totalSalesValueMin > 0 ? totalSalesValueMin : null;
    payload.pendingSalesCountRange = enablePendingSales ? `${pendingSalesCountRangeArr[0]}~${pendingSalesCountRangeArr[1]}` : "";
    payload.pendingSalesCountMin = pendingSalesCountMin > 0 ? pendingSalesCountMin : null;
    payload.unpaidValueRange = enableUnpaidValue ? `${unpaidValueRangeArr[0]}~${unpaidValueRangeArr[1]}` : "";
    payload.unpaidValueMin = unpaidValueMin > 0 ? unpaidValueMin : null;
    payload.totalDiscountsRange = enableTotalDiscounts ? `${totalDiscountsRangeArr[0]}~${totalDiscountsRangeArr[1]}` : "";
    payload.totalDiscountsMin = totalDiscountsMin > 0 ? totalDiscountsMin : null;

    payload.recencyRange = enableRecency ? `${recencyRangeArr[0]}~${recencyRangeArr[1]}` : "";
    payload.recencyMin = recencyMin > 0 ? recencyMin : null;
    payload.tenureRange = enableTenure ? `${tenureRangeArr[0]}~${tenureRangeArr[1]}` : "";
    payload.tenureMin = tenureMin > 0 ? tenureMin : null;
    payload.payIntervalRange = enablePayInterval ? `${payIntervalRangeArr[0]}~${payIntervalRangeArr[1]}` : "";
    payload.payIntervalMin = payIntervalMin > 0 ? payIntervalMin : null;

    payload.profileType = profileType;

    // Genders and Marial to list formats -> ["1", "2"] which the backend converts
    payload.genders = JSON.stringify(selectedGenders.map(g => g.id));
    payload.marialStatus = JSON.stringify(selectedMarial.map(m => m.id));

    if (payload.id) {
      updateLoad({ data: payload });
    } else {
      saveLoad({ data: payload });
    }
  };

  const handleDelete = (id) => {
    if (window.confirm("Deseja realmente excluir este perfil? Promoções que dependem dele podem ser afetadas.")) {
      deleteLoad({ data: { id } });
    }
  };

  return (
    <PageContent>
      <UIContainer container direction="row">
        <Grid item xs={12} container justify="space-between" alignItems="center">
          <UIFormTitle id="tour-profiles-title" title="Gerenciar Perfis de Clientes" />
          <Button id="tour-profiles-new-btn" color="primary" variant="contained" onClick={() => handleOpenModal()}>
            Novo Perfil
          </Button>
        </Grid>
        
        <Grid item xs={12} style={{ marginTop: 16 }}>
          <Typography variant="body2" paragraph>
            Os perfis são utilizados para categorizar os clientes dinamicamente de acordo com suas faixas de idade, localização e mais estatísticas para o oferecimento automatizado através das campanhas.
          </Typography>
          {/* Tabela Desktop */}
          <Hidden smDown>
            <TableContainer id="tour-profiles-table" component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Idades</TableCell>
                    <TableCell>Cidades Suportadas</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {info.loading && <TableRow><TableCell colSpan={5}>Carregando...</TableCell></TableRow>}
                  {!info.loading && profiles.map((p) => (
                    <TableRow key={p.id}>
                      <TableCell>{p.id}</TableCell>
                      <TableCell>{p.name}</TableCell>
                      <TableCell>{p.ageRange || 'Qualquer'}</TableCell>
                      <TableCell>
                         {(!p.cities || p.cities.toUpperCase() === 'NULL' || p.cities === "") ? 'Qualquer' : 
                           (p.cities.length > 50 ? `${p.cities.substring(0, 50)}...` : p.cities)}
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Editar perfil">
                          <IconButton size="small" onClick={() => handleOpenModal(p)}>
                            <EditIcon color="primary" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir perfil">
                          <IconButton size="small" onClick={() => handleDelete(p.id)}>
                            <DeleteIcon color="error" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                  {!info.loading && profiles.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">Nenhum perfil cadastrado</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Hidden>

          {/* Cards Mobile */}
          <Hidden mdUp>
            <Box style={{ width: '100%' }}>
              {info.loading && (
                <Typography color="textSecondary" align="center" style={{ padding: '16px 0' }}>
                  Carregando...
                </Typography>
              )}
              {!info.loading && profiles.map((p) => {
                const formattedCities = (!p.cities || p.cities.toUpperCase() === 'NULL' || p.cities === "") 
                  ? 'Qualquer' 
                  : (p.cities.length > 60 ? `${p.cities.substring(0, 60)}...` : p.cities);
                const isNegative = Number(p.profileType) === 2;

                return (
                  <Card
                    key={p.id}
                    variant="outlined"
                    style={{
                      marginBottom: 12,
                      borderLeft: `4px solid ${isNegative ? '#D32F2F' : '#17497F'}`,
                      borderRadius: 8,
                    }}
                  >
                    <CardContent style={{ paddingBottom: 8 }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                          #{p.id} - {p.name}
                        </Typography>
                        {p.profileType && (
                          <Chip
                            label={isNegative ? 'Negativo' : 'Positivo'}
                            size="small"
                            style={{
                              backgroundColor: isNegative ? '#FFEBEE' : '#E3F2FD',
                              color: isNegative ? '#D32F2F' : '#17497F',
                              fontWeight: 600,
                            }}
                          />
                        )}
                      </Box>
                      {p.description && (
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                          {p.description}
                        </Typography>
                      )}
                      <Divider style={{ margin: '8px 0' }} />
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary" display="block">
                            Faixa etária
                          </Typography>
                          <Typography variant="body2" style={{ fontWeight: 600 }}>
                            {p.ageRange || 'Qualquer'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary" display="block">
                            Cidades
                          </Typography>
                          <Typography variant="body2" style={{ fontWeight: 600 }}>
                            {formattedCities}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions style={{ justifyContent: 'flex-end', paddingTop: 0, paddingRight: 16, paddingBottom: 8 }}>
                      <Tooltip title="Editar perfil">
                        <IconButton size="small" onClick={() => handleOpenModal(p)}>
                          <EditIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir perfil">
                        <IconButton size="small" onClick={() => handleDelete(p.id)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </CardActions>
                  </Card>
                );
              })}
              {!info.loading && profiles.length === 0 && (
                <Typography color="textSecondary" align="center" style={{ padding: '16px 0' }}>
                  Nenhum perfil cadastrado
                </Typography>
              )}
            </Box>
          </Hidden>
        </Grid>

        {/* Modal de Criação / Edição */}
        <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="sm">
          <DialogTitle style={{ paddingBottom: 4 }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <div>
                <Typography variant="h6" style={{ fontWeight: 600 }}>
                  {selectedProfile?.id ? 'Editar Perfil' : 'Novo Perfil'}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Configure as regras para segmentação automática de clientes
                </Typography>
              </div>
              <IconButton size="small" onClick={() => startTour('customerProfilesModal')} style={{ marginTop: 4 }}>
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers style={{ padding: '16px 24px' }}>

            {/* ═══════════════ SEÇÃO: IDENTIFICAÇÃO ═══════════════ */}
            <Box id="tour-profile-section-identification" style={{ marginBottom: 24 }}>
              <Box display="flex" alignItems="center" style={{ marginBottom: 12 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  📋 Identificação
                </Typography>
              </Box>
              <Box style={{ 
                background: document.body?.className?.includes('dark') ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.015)',
                borderRadius: 8, padding: '16px 16px 8px'
              }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField 
                      required fullWidth label="Nome do Perfil" name="name" 
                      value={selectedProfile?.name || ''} onChange={handleChange} 
                      variant="outlined" size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField 
                      fullWidth label="Descrição Curta" name="description" 
                      value={selectedProfile?.description || ''} onChange={handleChange} 
                      variant="outlined" size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FilterRow title="Tipo de Perfil" emptyText="Padrão" hasValue={true} onClear={() => setProfileType(1)}>
                       <Box display="flex" gridGap={8}>
                         <Button 
                            variant={profileType === 1 ? "contained" : "outlined"} 
                            color="primary" 
                            onClick={() => setProfileType(1)}
                            style={profileType === 1 ? { background: '#2196f3', color: 'white' } : {}}
                          >
                           Perfil Bom
                         </Button>
                         <Button 
                            variant={profileType === 2 ? "contained" : "outlined"} 
                            color="secondary" 
                            onClick={() => setProfileType(2)}
                            style={profileType === 2 ? { background: '#f44336', color: 'white' } : {}}
                          >
                           Perfil Ruim
                         </Button>
                       </Box>
                    </FilterRow>
                  </Grid>
                </Grid>
              </Box>
            </Box>

            {/* ═══════════════ SEÇÃO: PERFIL DEMOGRÁFICO ═══════════════ */}
            <Box id="tour-profile-section-demographic" style={{ marginBottom: 24 }}>
              <Box display="flex" alignItems="center" style={{ marginBottom: 4 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  👤 Perfil Demográfico
                </Typography>
              </Box>
              <Divider style={{ marginBottom: 12 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Faixa Etária (Anos)" 
                    emptyText="Qualquer Idade" 
                    hasValue={enableAge} 
                    onClear={() => { setEnableAge(false); setAgeRangeArr([18, 65]); }}
                  >
                    <Slider
                      value={ageRangeArr}
                      onChange={(e, newVal) => { setAgeRangeArr(newVal); setEnableAge(true); }}
                      valueLabelDisplay="auto"
                      min={10} max={100}
                    />
                  </FilterRow>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Quantidade de Filhos" 
                    emptyText="Qualquer qtd. de filhos" 
                    hasValue={enableChildren} 
                    onClear={() => { setEnableChildren(false); setChildrenArr([0, 5]); }}
                  >
                    <Slider
                      value={childrenArr}
                      onChange={(e, newVal) => { setChildrenArr(newVal); setEnableChildren(true); }}
                      valueLabelDisplay="auto"
                      min={0} max={10}
                      marks
                    />
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Gênero" 
                    emptyText="Qualquer gênero" 
                    hasValue={selectedGenders.length > 0} 
                    onClear={() => setSelectedGenders([])}
                  >
                    <Autocomplete
                      multiple
                      options={GENDER_OPTIONS}
                      getOptionLabel={(option) => option.label || ""}
                      value={selectedGenders}
                      onChange={(event, newValue) => setSelectedGenders(newValue)}
                      renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Selecione" />}
                    />
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Estado Civil" 
                    emptyText="Qualquer estado civil" 
                    hasValue={selectedMarial.length > 0} 
                    onClear={() => setSelectedMarial([])}
                  >
                    <Autocomplete
                      multiple
                      options={MARIAL_STATUS_OPTIONS}
                      getOptionLabel={(option) => option.label || ""}
                      value={selectedMarial}
                      onChange={(event, newValue) => setSelectedMarial(newValue)}
                      renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Selecione" />}
                    />
                  </FilterRow>
                </Grid>
              </Grid>
            </Box>

            {/* ═══════════════ SEÇÃO: LOCALIZAÇÃO ═══════════════ */}
            <Box id="tour-profile-section-location" style={{ marginBottom: 24 }}>
              <Box display="flex" alignItems="center" style={{ marginBottom: 4 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  📍 Localização
                </Typography>
              </Box>
              <Divider style={{ marginBottom: 12 }} />
              <FilterRow 
                title="Cidades Suportadas" 
                emptyText="Qualquer cidade" 
                hasValue={selectedCities.length > 0} 
                onClear={() => setSelectedCities([])}
              >
                <Autocomplete
                  multiple
                  freeSolo
                  options={customersCities}
                  value={selectedCities}
                  onChange={(event, newValue) => setSelectedCities(newValue)}
                  renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Selecione ou digite" />}
                />
              </FilterRow>
            </Box>

            {/* ═══════════════ SEÇÃO: MÉTRICAS FINANCEIRAS ═══════════════ */}
            <Box id="tour-profile-section-financial" style={{ marginBottom: 24 }}>
              <Box display="flex" alignItems="center" style={{ marginBottom: 4 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  💰 Métricas Financeiras
                </Typography>
              </Box>
              <Divider style={{ marginBottom: 12 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Ticket Médio (R$)" 
                    emptyText="Qualquer" 
                    hasValue={enableTicketAvg || ticketAvgMin > 0} 
                    onClear={() => { setEnableTicketAvg(false); setTicketAvgMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: ticketAvgMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de valor</Typography>
                        <Slider
                          value={ticketAvgRangeArr}
                          onChange={(e, newVal) => { setTicketAvgRangeArr(newVal); setEnableTicketAvg(true); setTicketAvgMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={5000} step={50}
                          disabled={ticketAvgMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableTicketAvg ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Valor Mínimo" 
                          type="number" 
                          value={ticketAvgMin} 
                          onChange={(e) => { setTicketAvgMin(e.target.value); if (parseFloat(e.target.value) > 0) setEnableTicketAvg(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableTicketAvg}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FilterRow 
                    title="Total Gasto (R$)" 
                    emptyText="Qualquer" 
                    hasValue={enableTotalSales || totalSalesValueMin > 0} 
                    onClear={() => { setEnableTotalSales(false); settotalSalesValueMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: totalSalesValueMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de valor</Typography>
                        <Slider
                          value={totalSalesValueRangeArr}
                          onChange={(e, newVal) => { settotalSalesValueRangeArr(newVal); setEnableTotalSales(true); settotalSalesValueMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={20000} step={100}
                          disabled={totalSalesValueMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableTotalSales ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Valor Mínimo" 
                          type="number" 
                          value={totalSalesValueMin} 
                          onChange={(e) => { settotalSalesValueMin(e.target.value); if (parseFloat(e.target.value) > 0) setEnableTotalSales(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableTotalSales}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Vendas em Aberto" 
                    emptyText="Qualquer" 
                    hasValue={enablePendingSales || pendingSalesCountMin > 0} 
                    onClear={() => { setEnablePendingSales(false); setpendingSalesCountMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: pendingSalesCountMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de quantidade</Typography>
                        <Slider
                          value={pendingSalesCountRangeArr}
                          onChange={(e, newVal) => { setpendingSalesCountRangeArr(newVal); setEnablePendingSales(true); setpendingSalesCountMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={50}
                          disabled={pendingSalesCountMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enablePendingSales ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Qtd Mínima" 
                          type="number" 
                          value={pendingSalesCountMin} 
                          onChange={(e) => { setpendingSalesCountMin(e.target.value); if (parseInt(e.target.value) > 0) setEnablePendingSales(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enablePendingSales}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Valor Fiado (R$)" 
                    emptyText="Qualquer" 
                    hasValue={enableUnpaidValue || unpaidValueMin > 0} 
                    onClear={() => { setEnableUnpaidValue(false); setUnpaidValueMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: unpaidValueMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de valor</Typography>
                        <Slider
                          value={unpaidValueRangeArr}
                          onChange={(e, newVal) => { setUnpaidValueRangeArr(newVal); setEnableUnpaidValue(true); setUnpaidValueMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={5000} step={50}
                          disabled={unpaidValueMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableUnpaidValue ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Valor Mínimo" 
                          type="number" 
                          value={unpaidValueMin} 
                          onChange={(e) => { setUnpaidValueMin(e.target.value); if (parseFloat(e.target.value) > 0) setEnableUnpaidValue(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableUnpaidValue}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Descontos (R$)" 
                    emptyText="Qualquer" 
                    hasValue={enableTotalDiscounts || totalDiscountsMin > 0} 
                    onClear={() => { setEnableTotalDiscounts(false); setTotalDiscountsMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: totalDiscountsMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de valor</Typography>
                        <Slider
                          value={totalDiscountsRangeArr}
                          onChange={(e, newVal) => { setTotalDiscountsRangeArr(newVal); setEnableTotalDiscounts(true); setTotalDiscountsMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={2000} step={20}
                          disabled={totalDiscountsMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableTotalDiscounts ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Valor Mínimo" 
                          type="number" 
                          value={totalDiscountsMin} 
                          onChange={(e) => { setTotalDiscountsMin(e.target.value); if (parseFloat(e.target.value) > 0) setEnableTotalDiscounts(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableTotalDiscounts}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>
              </Grid>
            </Box>

            {/* ═══════════════ SEÇÃO: MÉTRICAS TEMPORAIS ═══════════════ */}
            <Box id="tour-profile-section-temporal" style={{ marginBottom: 8 }}>
              <Box display="flex" alignItems="center" style={{ marginBottom: 4 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, fontSize: '0.95rem' }}>
                  ⏱ Métricas Temporais
                </Typography>
              </Box>
              <Divider style={{ marginBottom: 12 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Última Compra (Dias)" 
                    emptyText="Qualquer" 
                    hasValue={enableRecency || recencyMin > 0} 
                    onClear={() => { setEnableRecency(false); setRecencyMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: recencyMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de dias</Typography>
                        <Slider
                          value={recencyRangeArr}
                          onChange={(e, newVal) => { setRecencyRangeArr(newVal); setEnableRecency(true); setRecencyMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={365}
                          disabled={recencyMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableRecency ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Mínimo de dias" 
                          type="number" 
                          value={recencyMin} 
                          onChange={(e) => { setRecencyMin(e.target.value); if (parseInt(e.target.value) > 0) setEnableRecency(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableRecency}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Tempo de Casa (Dias)" 
                    emptyText="Qualquer" 
                    hasValue={enableTenure || tenureMin > 0} 
                    onClear={() => { setEnableTenure(false); setTenureMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: tenureMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Faixa de dias</Typography>
                        <Slider
                          value={tenureRangeArr}
                          onChange={(e, newVal) => { setTenureRangeArr(newVal); setEnableTenure(true); setTenureMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={1825}
                          disabled={tenureMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enableTenure ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Mínimo de dias" 
                          type="number" 
                          value={tenureMin} 
                          onChange={(e) => { setTenureMin(e.target.value); if (parseInt(e.target.value) > 0) setEnableTenure(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enableTenure}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FilterRow 
                    title="Freq. de Pagamento (Dias)" 
                    emptyText="Qualquer" 
                    hasValue={enablePayInterval || payIntervalMin > 0} 
                    onClear={() => { setEnablePayInterval(false); setPayIntervalMin(0); }}
                  >
                    <Box>
                      <Box style={{ opacity: payIntervalMin > 0 ? 0.4 : 1, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption">Intervalo médio (dias)</Typography>
                        <Slider
                          value={payIntervalRangeArr}
                          onChange={(e, newVal) => { setPayIntervalRangeArr(newVal); setEnablePayInterval(true); setPayIntervalMin(0); }}
                          valueLabelDisplay="auto"
                          min={0} max={90}
                          disabled={payIntervalMin > 0}
                        />
                      </Box>
                      <Box style={{ opacity: enablePayInterval ? 0.4 : 1, transition: 'opacity 0.2s', marginTop: 8 }}>
                        <TextField 
                          label="Mínimo (dias)" 
                          type="number" 
                          value={payIntervalMin} 
                          onChange={(e) => { setPayIntervalMin(e.target.value); if (parseFloat(e.target.value) > 0) setEnablePayInterval(false); }}
                          fullWidth size="small" margin="dense"
                          disabled={enablePayInterval}
                        />
                      </Box>
                    </Box>
                  </FilterRow>
                </Grid>
              </Grid>
            </Box>

          </DialogContent>
          <DialogActions style={{ padding: '12px 24px' }}>
            <Button onClick={() => setOpenModal(false)} disabled={saveInfo.loading || updateInfo.loading}>
              Cancelar
            </Button>
            <Button color="primary" variant="contained" onClick={handleSave} disabled={saveInfo.loading || updateInfo.loading}>
              {saveInfo.loading || updateInfo.loading ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          </DialogActions>
        </Dialog>

      </UIContainer>
    </PageContent>
  );
};

export default PerfisCliente;

